(() => {
  'use strict';

  const cleanTerm = (value = '') =>
    value.trim().replace(/\*+$/, '');

  const makePreciseTerm = (value = '') =>
    cleanTerm(value);

  const isSearchUrl = (value) => {
    try {
      const url = new URL(value, window.location.origin);
      return /\/search\/?$/.test(url.pathname);
    } catch (_) {
      return false;
    }
  };

  const limitFormToProducts = (form) => {
    let typeInput = form.querySelector('[name="type"]');

    if (!typeInput) {
      typeInput = document.createElement('input');
      typeInput.type = 'hidden';
      typeInput.name = 'type';
      form.appendChild(typeInput);
    }

    typeInput.value = 'product';
  };

  const cleanVisibleSearch = () => {
    if (!/\/search\/?$/.test(window.location.pathname)) return;

    document
      .querySelectorAll('form input[name="q"]')
      .forEach((input) => {
        input.value = cleanTerm(input.value);
      });
  };

  // Captura o envio normal do formulário.
  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;

      if (!(form instanceof HTMLFormElement)) return;
      if (!isSearchUrl(form.action)) return;

      const input = form.querySelector('input[name="q"]');
      if (!input) return;

      input.value = makePreciseTerm(input.value);
      limitFormToProducts(form);
    },
    true
  );

  /*
   * Alguns temas, inclusive a busca preditiva, não enviam o formulário ao
   * pressionar Enter. Eles clicam no link "Pesquisar por...". Este listener
   * corrige também esse caminho antes de o navegador abrir a página.
   */
  document.addEventListener(
    'click',
    (event) => {
      const link = event.target.closest(
        'predictive-search a[href], [data-predictive-search] a[href]'
      );

      if (!link || !isSearchUrl(link.href)) return;

      const url = new URL(link.href, window.location.origin);
      const query = url.searchParams.get('q');
      if (!query) return;

      url.searchParams.set('q', makePreciseTerm(query));
      url.searchParams.set('type', 'product');
      link.href = url.toString();
    },
    true
  );

  document.addEventListener('DOMContentLoaded', cleanVisibleSearch);
  window.addEventListener('pageshow', cleanVisibleSearch);
})();